export const loadStamped = async () => {
  if (window.StampedFn) {
    await window.StampedFn.init({
      apiKey: `${process.env.GATSBY_STOMPED_PUBLIC_KEY_ID}`,
      storeUrl: `${process.env.GATSBY_STOMPED_STORE_URL}`,
    })
    window.StampedFn.loadBadges()
  }
}
